import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { Form } from 'react-bootstrap';

import {
  BRANDS_BY_IDS,
  BRANDS_FOR_DROPDOWN,
  getURLWithSearchParams,
} from 'lib/networking/endpoints';
import ProductListFilter from 'lib/enums/ProductListFilter';
import { removeEmpty } from 'lib/utils/objectUtils';
import { httpGet } from 'lib/networking/http';
import SearchableScrollableMultiSelect from 'components/shared/SearchableScrollableMultiSelect';

function BrandFilter({ selectedValues, updateFilters, selectedManufacturerId = null }) {
  const [initOptions, setInitOptions] = useState([]);
  const prevManufacturerIdRef = useRef(selectedManufacturerId);

  // initial load
  useEffect(() => {
    const url = getURLWithSearchParams(
      BRANDS_BY_IDS,
      removeEmpty({
        ids: selectedValues?.length ? selectedValues?.join(',') : null,
      }),
    );
    httpGet(url).then(res => {
      if (res.status === 200) {
        const brands = res.data?.data;
        if (brands?.length) {
          setInitOptions(
            brands.map(brand => ({
              label: brand.global_manufacturer_name
                ? `${brand.name} by ${brand.global_manufacturer_name}`
                : brand.name,
              value: brand.id,
            })),
          );
        }
      }
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // reset selected brands when manufacturer changes
  useEffect(() => {
    if (prevManufacturerIdRef.current !== selectedManufacturerId) {
      setInitOptions([]);
      updateFilters(ProductListFilter.BRAND_IDS, []);
      prevManufacturerIdRef.current = selectedManufacturerId;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedManufacturerId]);

  return (
    <Form.Group>
      <Form.Label>Select Brands</Form.Label>
      <SearchableScrollableMultiSelect
        additionalParams={{ manufacturer_id: selectedManufacturerId }}
        onChange={options =>
          updateFilters(
            ProductListFilter.BRAND_IDS,
            options?.map(option => option.value),
          )
        }
        fetchUrl={BRANDS_FOR_DROPDOWN}
        optionMapper={brand => ({
          label: brand.global_manufacturer_name
            ? `${brand.name} by ${brand.global_manufacturer_name}`
            : brand.name,
          value: brand.id,
        })}
        initOptions={initOptions}
      />
    </Form.Group>
  );
}

BrandFilter.propTypes = {
  selectedValues: PropTypes.array,
  updateFilters: PropTypes.func,
  selectedManufacturerId: PropTypes.string,
};

export default BrandFilter;
